import { 
  FaCoins, 
  FaHeartbeat, 
  FaGraduationCap, 
  FaCloud, 
  FaShoppingBag, 
  FaLeaf, 
  FaBuilding 
} from 'react-icons/fa';

export const industriesData = [
  {
    id: 'fintech',
    title: 'FinTech (Financial Technology)',
    icon: <FaCoins />,
    description: 'Transforming financial services with secure, scalable, and compliant digital solutions.',
    image: '/assets/FinTech.png',
    services: [
      'Digital payments & wallets',
      'Banking, lending & credit platforms',
      'InsurTech (insurance technology)',
      'WealthTech, blockchain & crypto'
    ]
  },
  {
    id: 'healthtech',
    title: 'HealthTech',
    icon: <FaHeartbeat />,
    description: 'Empowering healthcare providers with innovative digital tools for better patient outcomes.',
    image: '/assets/HealthTech.png',
    services: [
      'Telemedicine & e-clinics',
      'Medical devices & diagnostics',
      'Health data & AI-driven analytics',
      'Fitness, wellness & mental health'
    ]
  },
  {
    id: 'edutech',
    title: 'EduTech',
    icon: <FaGraduationCap />,
    description: 'Revolutionizing education through immersive and accessible learning platforms.',
    image: '/assets/EduTech.png',
    services: [
      'Online learning platforms & LMS',
      'Test prep & skill development',
      'Corporate training & upskilling',
      'AI-based learning & assessment tools'
    ]
  },
  {
    id: 'saas',
    title: 'SaaS (Software as a Service)',
    icon: <FaCloud />,
    description: 'Building scalable, multi-tenant cloud solutions for B2B and B2C markets.',
    image: '/assets/SaaS.png',
    services: [
      'B2B & B2C cloud software',
      'CRM, ERP, HRTech tools',
      'Subscription-based digital platforms'
    ]
  },
  {
    id: 'ecommerce',
    title: 'E-commerce & D2C',
    icon: <FaShoppingBag />,
    description: 'Driving sales and customer engagement with next-gen e-commerce experiences.',
    image: '/assets/E-commerce.png',
    services: [
'Marketplaces & online retail',
'Social & quick commerce',
'Agri IoT & supply optimization'  
    ]
  },

  {
    id: 'proptech',
    title: 'PropTech & Real Estate Tech',
    icon: <FaBuilding />,
    description: 'Innovating real estate management and smart living solutions.',
    image: '/assets/PropTech.png',
    services: [
      'Property marketplaces',
      'Smart buildings & IoT',
      'Property management platforms'
    ]
  }
];
